module.exports = __webpack_public_path__ + "img/02.1761116a.png";